import React from "react";
import { Layout, QuickStarterBonus } from "../components";

const QuickStarterPage = () => {
  return (
    <>
      <Layout>
        <QuickStarterBonus />
      </Layout>
    </>
  );
};

export default QuickStarterPage;
